<style>
.jabatan table  tr th{
  text-align: center;
}
.jabatan table  td:nth-child(1){
  text-align: center;
}
</style>
<template>
  <div class="dynamic-tables">
    <Widget title="<h4>Jabatan</h4>" collapse close customHeader>
      <div class="form-group row">
        <div class="col-sm-6">
          <b-button variant="success" v-b-modal.modal-tambah><span class="glyphicon glyphicon-plus mb-2" /> Tambah
          </b-button>
        </div>
        <div class="col-sm-6 text-end">
        </div>
      </div>
      <div class="jabatan">
        <v-client-table :data="itemsWithNumber" :columns="columnsDatatable" :options="optionsJabatan">
          <div slot="aksi" slot-scope="props">
            <b-button variant="info" class="me-3" size="s" @click="getDetail(props.row)">
              <i class="glyphicon glyphicon-pencil text-white me-sm-1 mb-sm-2" />
              <span class="d-none d-md-inline-block text-white"> Edit</span>
            </b-button>
            <b-button style="margin-left:5px" variant="danger" class="me-3" size="s" @click="deleteData(props.row.id)">
              <i class="glyphicon glyphicon-trash text-white me-sm-1 mb-sm-2" />
              <span class="d-none d-md-inline-block text-white"> Hapus</span>
            </b-button>
          </div>
        </v-client-table>
      </div>
    </Widget>

    <!-- modal tambah -->
    <b-modal @hidden="resetForm" body-class="bg-white" id="modal-tambah" scrollable title="Tambah Data" cancel-title="Close"
      ok-title="Accept" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata">
        <b-form-group label="Nama" label-for="nama_jabatan" class="mb-3">
          <b-form-input v-validate="'required'" name="Nama Jabatan"
            :class="{ 'form-control': true, 'is-invalid': errors.has('Nama Jabatan') }" id="nama_jabatan"
            v-model="formJabatan.nama_jabatan" />
          <span class="text-danger" v-if="errors.has('Nama Jabatan')">
            {{ errors.first('Nama Jabatan') }}
          </span>
        </b-form-group>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="onSubmit">
            <i class="fa fa-floppy-o text-white" />
            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal edit -->
    <b-modal @hidden="resetForm" body-class="bg-white" id="modal-edit" scrollable title="Edit Data" cancel-title="Close" ok-title="Accept"
      cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata">
        <b-form-group label="Nama" label-for="nama_jabatan" class="mb-3">
          <b-form-input v-validate="'required'" name="Nama Jabatan"
            :class="{ 'form-control': true, 'is-invalid': errors.has('Nama Jabatan') }" id="nama_jabatan"
            v-model="formJabatan.nama_jabatan" />
          <span class="text-danger" v-if="errors.has('Nama Jabatan')">
            {{ errors.first('Nama Jabatan') }}
          </span>
        </b-form-group>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="editData(formJabatan.id)">
            <i class="fa fa-floppy-o text-white" />
            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
  
<script>
import Widget from '@/components/Widget/Widget';
import axios from 'axios';
import Swal from 'sweetalert2'
import { Validator } from 'vee-validate';

export default {
  name: 'Dynamic',
  components: { Widget },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem("baseapiPengendalian"),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      columnsDatatable: ['no','nama_jabatan', 'aksi'],
      formJabatan: {
        id: '',
        nama_jabatan: ''
      },
      dataJabatan: [],
      optionsJabatan: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: '', count: '', limit: '' },
        columnsClasses: { no: 'width-100' },
        skin: 'table table-striped',
        sortIcon: {
          base: 'fa text-muted', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort',
        },
      },
    };
  },
  mounted() {
    this.loaddata()
    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
  },
  computed: {
      itemsWithNumber() {
        return this.dataJabatan.map((d, index) => ({ ...d, no: index + 1 }))
      }
  },
  methods: {
    deleteData(id) {
      Swal.fire({
        title: 'Hapus Data?',
        // text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya'
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete(
              this.baseapiPengendalian + `api/jabatan/` + id,
              {
                headers: {
                  Authorization: `Bearer ` + this.user.accessToken
                }
              }
            )
            .then((res) => {
              this.$toasted.success("Berhasil Dihapus");
              this.loaddata()
              return res;
            })
            .catch((err) => {
              console.log(err)
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      })
    },
    async onSubmit() {
      await this.$validator.validateAll();
      if (this.$validator.errors.any()) return

      axios.post(this.baseapiPengendalian + 'api/jabatan', 
      {
        nama_jabatan: this.formJabatan.nama_jabatan,
        nama_jabatan_pendek: this.formJabatan.nama_jabatan,
      },
      {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ` + this.user.accessToken
        }
      })
        .then((res) => {
          this.$toasted.success("Berhasil Ditambah");
          this.loaddata()

          // Wait until the models are updated in the UI
          this.$nextTick(() => {
            this.$bvModal.hide('modal-tambah')
          });
          this.resetForm()
          return res;
        })
        .catch((err) => {
          console.log(err)
          this.$toasted.error(err.response.data.message);
          return err;
        });
    },

    async editData(id) {
      await this.$validator.validateAll();
      if (this.$validator.errors.any()) return

      axios
        .put(
          this.baseapiPengendalian + `api/jabatan/${id}`,
          {
            nama_jabatan: this.formJabatan.nama_jabatan,
            nama_jabatan_pendek: this.formJabatan.nama_jabatan,
          }
          , {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken
            }
          })
        .then((res) => {
          this.$toasted.success("Berhasil Diubah");
          this.loaddata()

          this.$nextTick(() => {
            this.$bvModal.hide('modal-edit')
          })
          this.resetForm()
          return res;
        })
        .catch((err) => {
          console.log(err)
          this.$toasted.error(err.response.data.message);
          return err;
        });
    },

    // loaddata user
    loaddata() {
      axios.get(this.baseapiPengendalian + "api/jabatan?limit=0", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataJabatan = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    // detail
    getDetail(row) {
      this.formJabatan = {
        id: row.id,
        nama_jabatan: row.nama_jabatan
      }
      this.$nextTick(() => {
        this.$bvModal.show('modal-edit')
      });
    },

    resetForm() {
      this.formJabatan = {
        nama_jabatan: ''
      }
    }
  },
};
</script>

<style src="./Jabatan.scss" lang="scss" />
  